import { createContext, useContext, useEffect, useState } from 'react'
import { io } from 'socket.io-client'
import { useAuth } from './AuthContext'
import { config } from '../config/config'

const SocketContext = createContext({})

export const useSocket = () => {
  const context = useContext(SocketContext)
  if (!context) {
    throw new Error('useSocket debe ser usado dentro de un SocketProvider')
  }
  return context
}

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null)
  const [connected, setConnected] = useState(false)
  const { user } = useAuth()

  useEffect(() => {
    if (!user) return

    const socketInstance = io(config.serverUrl, {
      transports: ['websocket', 'polling'],
      withCredentials: true
    })

    socketInstance.on('connect', () => {
      setConnected(true)
      console.log('Socket.IO conectado para actualizaciones en tiempo real')
    })

    socketInstance.on('disconnect', () => {
      setConnected(false)
    })

    // Reenviar eventos del servidor al frontend (Devices.jsx ya los escucha)
    socketInstance.on('device-last-seen-updated', (data) => {
      window.dispatchEvent(new CustomEvent('deviceLastSeenUpdated', { detail: data }))
    })

    socketInstance.on('device-location-updated', (data) => {
      window.dispatchEvent(new CustomEvent('deviceLocationUpdated', { detail: data }))
    })

    setSocket(socketInstance)

    return () => {
      socketInstance.disconnect()
      setSocket(null)
      setConnected(false)
    }
  }, [user])

  const joinRoom = (room) => {
    if (socket) socket.emit('join', room)
  }

  const leaveRoom = (room) => {
    if (socket) socket.emit('leave', room)
  }

  const sendCommand = () => {
    console.log('sendCommand llamado - usar HTTP en su lugar para enviar comandos')
  }

  const value = {
    socket,
    connected,
    joinRoom,
    leaveRoom,
    sendCommand
  }

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  )
}
